import createAccessToken from '@/entities/AccessToken'
import config from '@/config'

const KEY = 'accessToken'

const store = (accessToken) => {
  localStorage.setItem(KEY, JSON.stringify(accessToken))
}

const load = () => {
  const stored = config.accessToken
    ? JSON.stringify({ token: config.accessToken })
    : localStorage.getItem(KEY)
  if (!stored) {
    return
  }
  return createAccessToken(JSON.parse(stored))
}

const remove = () => {
  localStorage.removeItem(KEY)
}

export default {
  store,
  load,
  remove,
}
